import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { finishMicrosoftLogin } from '../lib/microsoftLogin';

/* /auth/microsoft — where Microsoft sends people back after signing in. Turns
   the code into an ID token, has the API check it, then opens AcuityFlo. */
const MicrosoftCallback = () => {
  const { loginWithMicrosoft } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const ran = useRef(false);   // React's dev double-run would spend the one-time code twice

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    (async () => {
      try {
        const proof = await finishMicrosoftLogin(window.location.search);
        await loginWithMicrosoft(proof);
        navigate('/workspaces', { replace: true });
      } catch (e) {
        setError(e.response?.data?.detail || e.message || 'Microsoft sign-in failed');
      }
    })();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-orange-50 to-amber-50 px-4">
      <div className="w-full max-w-md rounded-xl border bg-white p-8 text-center shadow-sm">
        <img src="/acuity-logo.png" alt="Acuity Professional" className="mx-auto h-12 object-contain" />
        {!error ? (
          <p className="mt-6 flex items-center justify-center gap-2 text-sm text-gray-600" data-testid="ms-signing-in">
            <Loader2 className="h-4 w-4 animate-spin" /> Signing you in…
          </p>
        ) : (
          <>
            <p className="mt-6 text-sm font-medium text-red-600" data-testid="ms-error">{error}</p>
            <Link to="/login" replace className="mt-4 inline-block text-sm font-medium text-orange-600 hover:text-orange-700">
              Back to sign in
            </Link>
          </>
        )}
      </div>
    </div>
  );
};

export default MicrosoftCallback;
